"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
exports.TabHeader = ({ index, onClick, width, label, isSelected, styleProps, tabItemCSS = "" }) => {
    return (react_1.default.createElement(styles_1.TabItem, { key: index, onClick: onClick, "data-item": index, isSelected: isSelected, width: width, styleProps: styleProps, tabItemCSS: tabItemCSS }, label));
};
exports.Tab = ({ children }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
